import * as userActions from '../user/actions';
import * as FOIVSmallSubThemesActions from './actions';
import { CLEAN_PERSISTED_STORAGE } from '~redux_related/GENERAL/actions';

const initialState = {
    list: null,
    isFetching: false,
    isLoaded: false,
    error: '',
};

export const FOIVSmallSubThemesReducer = (state = initialState, action) => {
    switch (action.type) {
        case FOIVSmallSubThemesActions.SET_FOIV_SMALL_SUB_THEMES_FETCHING:
            return {
                ...state,
                isFetching: action.isFetching,
            };

        case FOIVSmallSubThemesActions.SET_FOIV_SMALL_SUB_THEMES_ERROR:
            return {
                list: null,
                isFetching: false,
                isLoaded: true,
                error: action.error,
            };

        case FOIVSmallSubThemesActions.SET_FOIV_SMALL_SUB_THEMES:
            return {
                list: action.list,
                isFetching: false,
                isLoaded: true,
                error: '',
            };

        case FOIVSmallSubThemesActions.ABORT_FOIV_SMALL_SUB_THEMES_REQUEST:
            return initialState;

        case FOIVSmallSubThemesActions.CLEAN_FOIV_SMALL_SUB_THEMES:
            return initialState;

        case userActions.LOGOUT:
            return initialState;

        case userActions.LOGIN:
            return initialState;

        case CLEAN_PERSISTED_STORAGE:
            return initialState;

        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/redux_related/FOIVSmallSubThemes/reducer.js